import { CartItem } from "@/shared/utils/interfaces";
import { getFieldByLang, formatPrice } from "@/shared/utils/helpers";
import usePosMenuGetPriceHook from "@/shared/hooks/usePosMenuGetPriceHook";
import usePosSettingsHook from "@/shared/hooks/usePosSettingsHook";

interface PosMenuItemProps {
  topping: CartItem;
  onClick?: () => void;
  isSelected?: boolean;
  index: number;
}

const PosToppingItem = ({
  topping,
  onClick,
  isSelected,
  index,
}: PosMenuItemProps) => {
  const getPrice = usePosMenuGetPriceHook();
  const {
    settings: { color_palette, font_size },
  } = usePosSettingsHook();

  return (
    <div
      onClick={() => onClick?.()}
      style={{
        backgroundColor: color_palette[index % 8],
        fontSize: font_size,
        height: "8rem",
        padding: "0.5rem",
        fontWeight: 600,
        border: isSelected ? `0.5rem solid #46c35f` : "none",
        borderRadius: "0.5rem",
        cursor: "pointer",
      }}
    >
      <div
        style={{
          display: "flex",
          height: "100%",
          width: "100%",
          alignItems: "flex-start",
          justifyContent: "center",
          flexDirection: "column",
          color: "#fff",
        }}
      >
        <div
          style={{ display: "flex", flexDirection: "column", width: "100%" }}
        >
          <span>{getFieldByLang(topping.name)}</span>
          <div>{formatPrice(getPrice(topping))}</div>
        </div>
      </div>
    </div>
  );
};

export default PosToppingItem;
